import React, { useState } from 'react';

import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { cn } from '@/lib/utils';

export type LandingDropdownOption = {
  value: string;
  label: React.ReactNode;
  icon?: React.ReactNode;
  disabled?: boolean;
};

interface LandingDropdownProps {
  trigger: React.ReactNode | ((open: boolean) => React.ReactNode);
  options: LandingDropdownOption[];
  onSelect: (value: string) => void;
  align?: 'start' | 'center' | 'end';
  sideOffset?: number;
  contentClassName?: string;
  itemClassName?: string;
}

const LandingDropdown: React.FC<LandingDropdownProps> = ({
  trigger,
  options,
  onSelect,
  align = 'center',
  sideOffset = 8,
  contentClassName,
  itemClassName
}) => {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>{typeof trigger === 'function' ? trigger(open) : trigger}</PopoverTrigger>
      <PopoverContent
        align={align}
        sideOffset={sideOffset}
        className={cn(
          'z-50 bg-[#F5F5F5] w-max min-w-[var(--radix-popover-trigger-width)] rounded-[16px] border border-[#0013051A] p-0.5 font-geist text-[#0A0A0A] shadow-[0px_8px_24px_rgba(0,19,5,0.08)]',
          contentClassName
        )}
        onCloseAutoFocus={(event) => event.preventDefault()}
      >
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            disabled={option.disabled}
            onClick={() => {
              const selectedValue = option.value;
              setOpen(false);
              window.setTimeout(() => onSelect(selectedValue), 50);
            }}
            className={cn(
              'flex w-full items-center gap-2 rounded-[16px] px-4 py-2 text-left text-base font-normal leading-6 tracking-[-0.32px] text-[#0A0A0A] outline-none transition-colors hover:bg-[#5F46DE14] focus-visible:bg-[#5F46DE14] disabled:pointer-events-none disabled:opacity-50',
              itemClassName
            )}
          >
            {option.icon}
            <span>{option.label}</span>
          </button>
        ))}
      </PopoverContent>
    </Popover>
  );
};

export default LandingDropdown;
